// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------------------------------------------------------------------------------------------- */
/* --- page structure --------------------------------------------------------------------------------- */
/* ---------------------------------------------------------------------------------------------------- */

.jtk-demo-main {
  display: flex;
  /* height:100vh; */
  height: calc(100vh - 141px);
}

.jtk-demo-inner {
  display: flex;
}

.jtk-demo-main .description {
  font-size: 13px;
  padding: 13px;
}

.jtk-demo-main .description ul {
  margin: 0;
  padding: 0 0 0 20px;
}

.jtk-demo-main .description li {
  list-style-type: disc !important;
  margin: 3px 0;
}

.jtk-demo-canvas {
  background-color: white;
  display: flex;
  flex-grow: 1;
  position: relative;
}

.jtk-demo-rhs {
  display: flex;
  flex-direction: column;
  margin: 0;
  background-color: #f9f9f9;
  flex: 0 0 250px;
  padding: 20px 5px 0 5px;
}

.canvas-wide {
  margin-left: 0;
}

.miniview {
  position: absolute;
  top: 25px;
  right: 25px;
  z-index: 100;
}

.jtk-demo-dataset {
  overflow: auto;
  font-size: 12px;
  font-family: Courier, monospace;
}

.jtk-demo-dataset pre {
  white-space: pre-wrap;
}

.demo-title {
  float: left;
  font-size: 18px;
}

.controls {
  top: 25px;
  color: #fff;
  margin-right: 10px;
  position: absolute;
  left: 90%;
  z-index: 1;
  display: flex;
  font-size: 14px;
}

.controls i {
  background-color: #5184a0;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 4px;
  border: 1px solid white;
  font-size: 22px;
  font-style: normal;
  width: 24px;
  height: 24px;
}

.controls i:not(.selected-mode):hover {
  background-color: white;
  color: #5184a0;
  border: 1px solid #5184a0;
}

.controls i:not(.selected-mode):active {
  color: white;
  background-color: #1d9ea0;
  border: 1px solid white;
}

[undo],
[redo] {
  background-color: darkgray !important;
}
[undo]:hover,
[redo]:hover {
  background-color: darkgray !important;
  color: white !important;
  border: 1px solid white !important;
}
[can-undo='true'] [undo],
[can-redo='true'] [redo] {
  background-color: #3e7e9c !important;
}
[can-undo='true'] [undo]:hover,
[can-redo='true'] [redo]:hover {
  background-color: white !important;
  color: #5184a0 !important;
  border: 1px solid #5184a0 !important;
}

/* ------------------------ node palette -------------------- */

.node-palette {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.jtk-demo-sidebar {
  margin: 0;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sidebar-item {
  background-color: #ccc;
  border-radius: 11px;
  color: #585858;
  cursor: move;
  padding: 8px;
  width: 128px;
  text-align: center;
  margin: 10px;
  outline: none;
}

.sidebar-item.katavorio-clone-drag {
  margin: 0;
  border: 1px solid white;
}

.sidebar-item:hover,
.sidebar-item.katavorio-clone-drag {
  background-color: #5184a0;
  color: white;
}
/* ---------------------------------------------------------------------------------------------------- */
/* --- jsPlumb setup ---------------------------------------------------------------------------------- */
/* ---------------------------------------------------------------------------------------------------- */

.jtk-surface-pan {
  display: none;
}

.jtk-connector {
  z-index: 9;
}

.jtk-connector:hover,
.jtk-connector.jtk-hover {
  z-index: 10;
}

.jtk-endpoint {
  z-index: 12;
  opacity: 0.8;
  cursor: pointer;
}

.jtk-overlay {
  background-color: white;
  color: #434343;
  font-weight: 400;
  padding: 4px;
  z-index: 10;
}

.jtk-overlay.jtk-hover {
  color: #434343;
}

path {
  cursor: pointer;
}

.edit:hover {
  color: #ff8000;
}

.selected-mode {
  color: #e4f013;
}

.connect {
  width: 10px;
  height: 10px;
  background-color: #f76258;
  position: absolute;
  bottom: 13px;
  right: 5px;
}

/* header styles */

.demo-links {
  position: fixed;
  right: 0;
  top: 57px;
  font-size: 11px;
  background-color: white;
  opacity: 0.8;
  padding-right: 10px;
  padding-left: 5px;
  text-transform: uppercase;
  z-index: 100001;
}

.demo-links div {
  display: inline;
  margin-right: 7px;
  margin-left: 7px;
}

.demo-links i {
  padding: 4px;
}
/*
.jtk-node {
    border:1px solid;
    background-color: white;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    position: absolute;
    z-index: 11;
    overflow: hidden;
    min-width:80px;
    min-height:30px;
    width: auto;
    justify-content: center;
    align-items: center;
    display: flex;
}

.jtk-node .name {
    cursor: move;
    font-size: 13px;
    text-align: center;
}

.jtk-node .name span {
    cursor:pointer;
}

*/

/* icons */

.jtk-node .add,
.jtk-node .delete,
.jtk-node .node-edit {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 10px;
  padding-bottom: 2px;
}

.jtk-node .add:hover,
.jtk-node .delete:hover,
.jtk-node .node-edit,
.jtk-node .add.constant,
.jtk-node .delete.constant {
  color: white;
}

.jtk-node .add {
  right: 3px;
}

.jtk-node .add:after {
  content: '+';
}

.jtk-node .add:hover,
.jtk-node .add.constant {
  background-color: #4ea758;
}

.jtk-node .delete {
  left: 3px;
}

.jtk-node .delete:after {
  content: 'x';
}

.jtk-node .delete:hover,
.jtk-node .delete.constant {
  background-color: #d83f3f;
}

.jtk-node .node-edit:after {
  /* content:"✎"; */
}

.fa {
  /* display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal; */
}

.fa-plus:after {
  /* content:"+"; */
  margin-bottom: 0.2rem;
}

.fa-home:after {
  /* content:"⌂"; */
  margin-bottom: 0.4rem;
}

.fa-pencil:after {
  /* content:"✎"; */
}

.fa-arrows:after {
  /* content:"✥"; */
}

.fa-undo:after {
  content: '↺';
}

.fa-repeat:after {
  content: '↻';
}

.fa-times:after {
  content: 'x';
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/jsplumbtoolkit-demo-support.css"],"names":[],"mappings":"AAAA,yGAAyG;AACzG,yGAAyG;AACzG,yGAAyG;;AAEzG;EACE,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,qCAAqC;AACvC;AACA;;EAEE,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;AACpC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;AACA,yGAAyG;AACzG,yGAAyG;AACzG,yGAAyG;;AAEzG;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA,kBAAkB;;AAElB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC;;AAED,UAAU;;AAEV;;;EAGE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;;yBAGuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* ---------------------------------------------------------------------------------------------------- */\r\n/* --- page structure --------------------------------------------------------------------------------- */\r\n/* ---------------------------------------------------------------------------------------------------- */\r\n\r\n.jtk-demo-main {\r\n  display: flex;\r\n  /* height:100vh; */\r\n  height: calc(100vh - 141px);\r\n}\r\n\r\n.jtk-demo-inner {\r\n  display: flex;\r\n}\r\n\r\n.jtk-demo-main .description {\r\n  font-size: 13px;\r\n  padding: 13px;\r\n}\r\n\r\n.jtk-demo-main .description ul {\r\n  margin: 0;\r\n  padding: 0 0 0 20px;\r\n}\r\n\r\n.jtk-demo-main .description li {\r\n  list-style-type: disc !important;\r\n  margin: 3px 0;\r\n}\r\n\r\n.jtk-demo-canvas {\r\n  background-color: white;\r\n  display: flex;\r\n  flex-grow: 1;\r\n  position: relative;\r\n}\r\n\r\n.jtk-demo-rhs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0;\r\n  background-color: #f9f9f9;\r\n  flex: 0 0 250px;\r\n  padding: 20px 5px 0 5px;\r\n}\r\n\r\n.canvas-wide {\r\n  margin-left: 0;\r\n}\r\n\r\n.miniview {\r\n  position: absolute;\r\n  top: 25px;\r\n  right: 25px;\r\n  z-index: 100;\r\n}\r\n\r\n.jtk-demo-dataset {\r\n  overflow: auto;\r\n  font-size: 12px;\r\n  font-family: Courier, monospace;\r\n}\r\n\r\n.jtk-demo-dataset pre {\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.demo-title {\r\n  float: left;\r\n  font-size: 18px;\r\n}\r\n\r\n.controls {\r\n  top: 25px;\r\n  color: #fff;\r\n  margin-right: 10px;\r\n  position: absolute;\r\n  left: 90%;\r\n  z-index: 1;\r\n  display: flex;\r\n  font-size: 14px;\r\n}\r\n\r\n.controls i {\r\n  background-color: #5184a0;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  margin-right: 4px;\r\n  border: 1px solid white;\r\n  font-size: 22px;\r\n  font-style: normal;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n.controls i:not(.selected-mode):hover {\r\n  background-color: white;\r\n  color: #5184a0;\r\n  border: 1px solid #5184a0;\r\n}\r\n\r\n.controls i:not(.selected-mode):active {\r\n  color: white;\r\n  background-color: #1d9ea0;\r\n  border: 1px solid white;\r\n}\r\n\r\n[undo],\r\n[redo] {\r\n  background-color: darkgray !important;\r\n}\r\n[undo]:hover,\r\n[redo]:hover {\r\n  background-color: darkgray !important;\r\n  color: white !important;\r\n  border: 1px solid white !important;\r\n}\r\n[can-undo='true'] [undo],\r\n[can-redo='true'] [redo] {\r\n  background-color: #3e7e9c !important;\r\n}\r\n[can-undo='true'] [undo]:hover,\r\n[can-redo='true'] [redo]:hover {\r\n  background-color: white !important;\r\n  color: #5184a0 !important;\r\n  border: 1px solid #5184a0 !important;\r\n}\r\n\r\n/* ------------------------ node palette -------------------- */\r\n\r\n.node-palette {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.jtk-demo-sidebar {\r\n  margin: 0;\r\n  padding: 10px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.sidebar-item {\r\n  background-color: #ccc;\r\n  border-radius: 11px;\r\n  color: #585858;\r\n  cursor: move;\r\n  padding: 8px;\r\n  width: 128px;\r\n  text-align: center;\r\n  margin: 10px;\r\n  outline: none;\r\n}\r\n\r\n.sidebar-item.katavorio-clone-drag {\r\n  margin: 0;\r\n  border: 1px solid white;\r\n}\r\n\r\n.sidebar-item:hover,\r\n.sidebar-item.katavorio-clone-drag {\r\n  background-color: #5184a0;\r\n  color: white;\r\n}\r\n/* ---------------------------------------------------------------------------------------------------- */\r\n/* --- jsPlumb setup ---------------------------------------------------------------------------------- */\r\n/* ---------------------------------------------------------------------------------------------------- */\r\n\r\n.jtk-surface-pan {\r\n  display: none;\r\n}\r\n\r\n.jtk-connector {\r\n  z-index: 9;\r\n}\r\n\r\n.jtk-connector:hover,\r\n.jtk-connector.jtk-hover {\r\n  z-index: 10;\r\n}\r\n\r\n.jtk-endpoint {\r\n  z-index: 12;\r\n  opacity: 0.8;\r\n  cursor: pointer;\r\n}\r\n\r\n.jtk-overlay {\r\n  background-color: white;\r\n  color: #434343;\r\n  font-weight: 400;\r\n  padding: 4px;\r\n  z-index: 10;\r\n}\r\n\r\n.jtk-overlay.jtk-hover {\r\n  color: #434343;\r\n}\r\n\r\npath {\r\n  cursor: pointer;\r\n}\r\n\r\n.edit:hover {\r\n  color: #ff8000;\r\n}\r\n\r\n.selected-mode {\r\n  color: #e4f013;\r\n}\r\n\r\n.connect {\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #f76258;\r\n  position: absolute;\r\n  bottom: 13px;\r\n  right: 5px;\r\n}\r\n\r\n/* header styles */\r\n\r\n.demo-links {\r\n  position: fixed;\r\n  right: 0;\r\n  top: 57px;\r\n  font-size: 11px;\r\n  background-color: white;\r\n  opacity: 0.8;\r\n  padding-right: 10px;\r\n  padding-left: 5px;\r\n  text-transform: uppercase;\r\n  z-index: 100001;\r\n}\r\n\r\n.demo-links div {\r\n  display: inline;\r\n  margin-right: 7px;\r\n  margin-left: 7px;\r\n}\r\n\r\n.demo-links i {\r\n  padding: 4px;\r\n}\r\n/*\r\n.jtk-node {\r\n    border:1px solid;\r\n    background-color: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    position: absolute;\r\n    z-index: 11;\r\n    overflow: hidden;\r\n    min-width:80px;\r\n    min-height:30px;\r\n    width: auto;\r\n    justify-content: center;\r\n    align-items: center;\r\n    display: flex;\r\n}\r\n\r\n.jtk-node .name {\r\n    cursor: move;\r\n    font-size: 13px;\r\n    text-align: center;\r\n}\r\n\r\n.jtk-node .name span {\r\n    cursor:pointer;\r\n}\r\n\r\n*/\r\n\r\n/* icons */\r\n\r\n.jtk-node .add,\r\n.jtk-node .delete,\r\n.jtk-node .node-edit {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  font-size: 10px;\r\n  padding-bottom: 2px;\r\n}\r\n\r\n.jtk-node .add:hover,\r\n.jtk-node .delete:hover,\r\n.jtk-node .node-edit,\r\n.jtk-node .add.constant,\r\n.jtk-node .delete.constant {\r\n  color: white;\r\n}\r\n\r\n.jtk-node .add {\r\n  right: 3px;\r\n}\r\n\r\n.jtk-node .add:after {\r\n  content: '+';\r\n}\r\n\r\n.jtk-node .add:hover,\r\n.jtk-node .add.constant {\r\n  background-color: #4ea758;\r\n}\r\n\r\n.jtk-node .delete {\r\n  left: 3px;\r\n}\r\n\r\n.jtk-node .delete:after {\r\n  content: 'x';\r\n}\r\n\r\n.jtk-node .delete:hover,\r\n.jtk-node .delete.constant {\r\n  background-color: #d83f3f;\r\n}\r\n\r\n.jtk-node .node-edit:after {\r\n  /* content:\"✎\"; */\r\n}\r\n\r\n.fa {\r\n  /* display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-style: normal; */\r\n}\r\n\r\n.fa-plus:after {\r\n  /* content:\"+\"; */\r\n  margin-bottom: 0.2rem;\r\n}\r\n\r\n.fa-home:after {\r\n  /* content:\"⌂\"; */\r\n  margin-bottom: 0.4rem;\r\n}\r\n\r\n.fa-pencil:after {\r\n  /* content:\"✎\"; */\r\n}\r\n\r\n.fa-arrows:after {\r\n  /* content:\"✥\"; */\r\n}\r\n\r\n.fa-undo:after {\r\n  content: '↺';\r\n}\r\n\r\n.fa-repeat:after {\r\n  content: '↻';\r\n}\r\n\r\n.fa-times:after {\r\n  content: 'x';\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
